import React from 'react';
import { MotifInput } from '@ey-xd/motif-react';

export default (props) => {
  const [value, setValue] = React.useState(
    props.data ? props.data[props.colDef.field] : ''
  );

  const handleChange = (e) => {
    setValue(e.target.value);
    props.handleOtherServiceNameChange(
      e.target.value,
      props.data.uniqueKey,
      props.colDef.field
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <MotifInput
        type="text"
        name={`otherServiceName.${props.data.uniqueKey}`}
        id={`otherServiceName.${props.data.uniqueKey}`}
        onChange={handleChange}
        value={value}
        hideClearButton={true}
        placeholder="Service Name"
        data-testid="txtOtherServiceName"
      />
    </div>
  );
};
